import { logWarn } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';

import { getErrorMessage } from './getErrorMessage';

const LOGGING_COMPONENT = 'grpcFetchClientWrapper';

export const logGrpcClientWarn = ({
  body,
  clientName,
  component,
  error,
  headers,
  httpStatusCode,
  message,
}: {
  clientName: string;
  message: string;
  error: unknown;
  headers?: HeadersInit;
  body?: Record<string, unknown>;
  httpStatusCode?: number;
  component?: string;
}) => {
  logWarn({
    component: component ?? LOGGING_COMPONENT,
    error: getErrorMessage(error),
    message: `${clientName} ${message}`,
    requestBody: body ? JSON.stringify(body) : String(body),
    headers: headers ? JSON.stringify(headers) : String(headers),
    status: String(httpStatusCode),
  });
};
